import request from '@/utils/request'

// 分页查询GESP编程题，params: { pageNum, pageSize, keyword, difficulty, repoId }
export function pagingGespQuestions(params) {
  return request({
    url: '/gesp-questions/paging',
    method: 'get',
    params
  })
}

// 根据ID获取单题详情
export function getGespQuestionById(id) {
  return request({
    url: `/gesp-questions/single/${id}`,
    method: 'get'
  })
}

// 单题添加
export function addGespQuestion(data) {
  return request({
    url: '/gesp-questions/single',
    method: 'post',
    data
  })
}

// 批量保存
export function saveGespQuestions(data) {
  return request({
    url: '/gesp-questions/saveQuestions',
    method: 'post',
    data
  })
}

// 修改试题
export function updateGespQuestion(id, data) {
  return request({
    url: `/gesp-questions/${id}`,
    method: 'put',
    data
  })
}

// 删除单个试题
export function deleteGespQuestion(id) {
  return request({
    url: `/gesp-questions/${id}`,
    method: 'delete'
  })
}

// 批量删除
export function batchDeleteGespQuestions(ids) {
  return request({
    url: '/gesp-questions/batch',
    method: 'delete',
    data: { ids }
  })
}
